import * as yup from 'yup';
import { FieldValidator } from '../../../types';

export const validator: FieldValidator = ({ initResponse }, t) =>
  yup.object({
    filePreview: yup.array().when('isPublishing', {
      is: true,
      then: schema =>
        schema.test(
          'needs-preview',
          t('deviationSubmit.validation.error.filePreview.required'),
          () => !(initResponse?.requiresPreview && !initResponse.hasCustomPreview)
        ),
    }),
  });
